/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DistributeOnboardingCandidateRequestBody = {
  /**
   * Opaque current distribution version token from getOnboarding.
   */
  expectedVersion: string;
  /**
   * Exact workflow-selected project slug.
   */
  projectSlug: string;
};

/** @internal */
export type DistributeOnboardingCandidateRequestBody$Outbound = {
  expected_version: string;
  project_slug: string;
};

/** @internal */
export const DistributeOnboardingCandidateRequestBody$outboundSchema:
  z.ZodMiniType<
    DistributeOnboardingCandidateRequestBody$Outbound,
    DistributeOnboardingCandidateRequestBody
  > = z.pipe(
    z.object({
      expectedVersion: z.string(),
      projectSlug: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        expectedVersion: "expected_version",
        projectSlug: "project_slug",
      });
    }),
  );

export function distributeOnboardingCandidateRequestBodyToJSON(
  distributeOnboardingCandidateRequestBody:
    DistributeOnboardingCandidateRequestBody,
): string {
  return JSON.stringify(
    DistributeOnboardingCandidateRequestBody$outboundSchema.parse(
      distributeOnboardingCandidateRequestBody,
    ),
  );
}
